export default __webpack_public_path__ + "static/media/photo--lg--hockey4.3739ea45.jpg";